import { useEffect, useMemo, useSyncExternalStore } from 'react';
import { ChatController, type ChatState } from './core/controller';

/** Тонка обгортка: створює контролер і підписує React на його стан. */
export function useChat(wsUrl: string, lang: string): { chat: ChatController; state: ChatState } {
  const chat = useMemo(() => new ChatController({ wsUrl, lang }), [wsUrl, lang]);
  const state = useSyncExternalStore(chat.subscribe, chat.getState);
  useEffect(() => () => chat.dispose(), [chat]);
  return { chat, state };
}
